module.exports = __webpack_public_path__ + "img/Lot5.134b8eab.jpg";